import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "./pages/Home";
import SectorAlcohol from "./pages/SectorAlcohol";
import SectorHidrocarburos from "./pages/SectorHidrocarburos";
import { AvisoLegal, PoliticaPrivacidad } from "./pages/Legal";
import ScrollManager from "./components/ScrollManager";

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sectores/alcohol" element={<SectorAlcohol />} />
        <Route path="/sectores/hidrocarburos" element={<SectorHidrocarburos />} />
        <Route path="/aviso-legal" element={<AvisoLegal />} />
        <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Toaster position="bottom-center" theme="dark" richColors />
    </BrowserRouter>
  );
}

export default App;
